import { render, staticRenderFns } from "./DispatchModal.vue?vue&type=template&id=418b814a&scoped=true&"
import script from "./DispatchModal.vue?vue&type=script&lang=js&"
export * from "./DispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./DispatchModal.vue?vue&type=style&index=0&id=418b814a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418b814a",
  null
  
)

export default component.exports